import { create } from './create';

export const schemes = {
  create,
};
